import * as React from 'react';

interface IProps{
    idk: string;
}

export default class NavNotifier extends React.Component<IProps & React.CSSProperties, any>{

    constructor(props){
        super(props)

        this.state = {

        };
    }

    public componentDidMount(){
        //if(!this.props.vertical)
          window.addEventListener('scroll', this.handleScroll); 

          this.handleScroll(undefined);
    }
  
  
    public componentWillUnmount(){
      //if(!this.props.vertical)
          window.removeEventListener('scroll', this.handleScroll)
    }


    getDocHeight() {
        return Math.max(
            document.body.scrollHeight, document.documentElement.scrollHeight,
            document.body.offsetHeight, document.documentElement.offsetHeight,
            document.body.clientHeight, document.documentElement.clientHeight
        );
    }

    handleScroll = (e) => {
    const st = window.scrollY;

    // Make sure they scroll more than delta
    
    const delta = 20;

    const positionInWholeScreen = this.self.offsetTop  - delta;
    //if(this.self)
    
    if(positionInWholeScreen <= st){
        (window as any).store.dispatch({type: 'CHANGE_CONTAINER', container: {idk: this.props.idk}});
    }

}

    self: any;

    render(){
        return (
            <div ref={e => this.self = e}>
                {this.props.children}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/core/ui/nav-notifier.tsx